module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pause":"Stop"},"de":{"pause":"Stopp"},"fr":{"pause":"Stop"},"it":{"pause":"Fermarsi"}}')
  delete Component.options._Ctor
}
